<template>
  <div class="i-filter-item-search">
    <SearchText
      v-model="term"
      :initialValue="filterParamValue"
      :placeholder="LANG.searchInDocuments"
      class="fts-as-you-type"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapBrowserMutations } from '@/store';
import { debounce } from 'lodash';
import SearchText from '@/components/common/SearchText.vue';

export default {
  props: {
    item: Object,
  },
  components: {
    SearchText,
  },
  data: () => ({
    term: '',
    lastSort: { order: '', desc: 1 },
    termWasRelevance: false,
  }),
  methods: {
    ...mapBrowserMutations([
      'setFilterParam',
    ]),
    setFilterParamDebounced: debounce(function (...args) {
      this.setFilterParam(...args);
    }, 500),
  },
  computed: {
    ...mapState(['LANG']),
    filterParamValue() {
      return this.item.value && this.item.value[0];
    },
  },
  watch: {
    // NOTE: we cannot debounce the `term` state directly
    // because this will make the input component unresponsive (debounced)
    // instead, we keep the `term` as local state
    // and debounce the `filter` value
    // This forces us to manually sync the `term` to the `filter value` and vice-verca
    // 1. `term` -> `filter` (sync `term` to the filter value using a debounced setter)
    term(value) {
      this.setFilterParamDebounced({
        name: this.item.name,
        value: [value],
      });
    },
    // 2. `filter` -> `term`
    // sync the input value to the filterParam value (when changed externally)
    // mimics `controlled` behavior of the term
    filterParamValue(value) {
      this.term = value;
    },
  },
};
</script>

<style scoped>
.i-filter-item-search {
  width: 200px;
}
</style>
